import React, { useRef, FunctionComponent, MouseEvent, ReactElement } from 'react'

const Link: FunctionComponent<LinkProps> = ({ setSelection, children }) => {
  const linkRef: React.MutableRefObject<HTMLAnchorElement> = useRef()

  const handleClick = (e: MouseEvent) => {
    e.preventDefault()
    setSelection(linkRef.current)
  }

  return (
    <a ref={linkRef} href={null} onClick={handleClick} className='pointer'>
      {children}
    </a>
  )
}

interface LinkProps {
  setSelection: (ref: HTMLElement) => void;
  children: ReactElement;
}

export default Link
